var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-content',[_c('common-table',{ref:"table",attrs:{"path":"web/camera","columns":_vm.columns},scopedSlots:_vm._u([{key:"logo",fn:function(ref){
var record = ref.record;
return [_c('a-avatar',{attrs:{"shape":"square","size":30,"src":record.avatarUrl}},[_vm._v(_vm._s(record.nickName))])]}},{key:"operation",fn:function(ref){
var record = ref.record;
return [_c('action-view',{on:{"click":function($event){return _vm.view(record)}}})]}}])},[_c('template',{slot:"search"})],2),_c('CameraEdit',{ref:"cameraEdit",on:{"success":_vm.getList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }